import i18n from "../../../../../../constants/i18n";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import getCorePersonalStore from "../../../../../../stores/core/core-personal-store";
import getKhattabat101CMessagingStore from "../../../../../../stores/khattabat-stores/101c-stores/101c-messaging-store";
import getKhattabatSharedMessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";

const ReactivateKhattabaClient = withLiteObserverAndTheme<{
  conversationID: string;
  userID: number;
}>((props) => {
  const { theme, conversationID, userID } = props;
  const { colors, unitX } = theme;

  const conversationType =
    getKhattabatSharedMessagingStore(conversationID).conversationType.get();
  const isOneOOneCConversation = conversationType === "101C";
  const isKhattabaAiAdmin = getCorePersonalStore().isKhattabaAiAdmin.get();

  if (!isOneOOneCConversation || isKhattabaAiAdmin) {
    return;
  }

  const {
    hasBeenReactivated,
    stringifiedReactivatedAt,
    shouldShowReactivationProcess
  } =
    getKhattabat101CMessagingStore(
      userID
    ).getKhattabaClientToReactivateDetails();

  if (!shouldShowReactivationProcess) {
    return;
  }

  return hasBeenReactivated ? (
    <Et3Text
      fontFamily={"MEDIUM"}
      fontSize={20}
      text={stringifiedReactivatedAt}
      isSpan={false}
      color={colors.all.black}
      style={{
        width: "90%"
      }}
    />
  ) : (
    <ET3Div
      width={180}
      height={43}
      alignItems={"center"}
      fDirection={"column"}
      style={{
        backgroundColor: colors.all.green,
        borderRadius: 36 * unitX,
        cursor: "pointer"
      }}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {
        getKhattabat101CMessagingStore(
          userID
        ).requestReactivatingKhattabaClient();
      }}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={24}
        isSpan={false}
        text={i18n.get("NOTICE_EMAIL")}
        style={{}}
        color={colors.all.white}
      />
    </ET3Div>
  );
});

export default ReactivateKhattabaClient;
